const errors = {
  errorUpdatingTemplate: 'An error occurred while updating the template',
  errorUpdatingReport: 'An error occurred while updating the report',
  errorGeneratingReport: 'An error occurred while generating the report',
  errorDeletingReport: 'An error occurred while deleting the report',
  errorCreatingTemplate: 'An error occurred while creating the template',
  errorDeletingTemplate: 'An error occurred while deleting the template',
  errorDuplicatingTemplate: 'An error occurred while duplicating the template',
  errorExtractingData: 'An error occurred while extracting the data',
  errorTogglingLanguage: 'An error occurred while toggling the language filter',
  versionGuard: {
    updateRequired: 'Update Required',
    updateRequiredDescription:
      'Your app version ({{currentVersion}}) is outdated. Please update to version {{minVersion}} or higher to continue using the app.',
    genericMessage:
      'Please update to the latest version to continue using Voicefill Medical.',
    updateButton: 'Update App',
  },
  invalidCode: 'Invalid code. Please try again.',
  failedToSignIn: 'Invalid password. Please try again.',
  failedToSendCode: 'Failed to send code',
  failedToSignInWithGitHub: 'Failed to sign in with GitHub',
  errorBoundary: {
    title: 'Something went wrong',
    contactSupport: 'If the issue persists, please contact support.',
    tryAgain: 'Try again',
    backHome: 'Back to home',
  },
};

export default errors;
